import { Alert } from '@zopauk/web-ui';
import type { QuestionContext } from '@/utils/models/question';
import { type QuestionNotificationFragment, useQuestionQuery } from '@/utils/dato/generated';

/**
 * Can only be used in the context of a Question model
 */
const Notification = ({ pageContext }: { pageContext: QuestionContext } & QuestionNotificationFragment) => {
  const { data } = useQuestionQuery({ slug: pageContext.slug });

  if (data?.question) {
    return data.question.notificationToggle && data.question.notificationMessage ? (
      <div className="px-5 mb-8 mx-auto max-w-[700px]">
        <Alert variant="warning">{data.question.notificationMessage}</Alert>
      </div>
    ) : null;
  }

  return null;
};

export default Notification;
